import * as React from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
	({ className, ...props }, ref) => {
		return (
		<textarea
			className={cn(
				'flex min-h-[80px] w-full rounded-md field-surface field-border px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
				className
			)}
			ref={ref}
			{...props}
		/>
		);
	}
);
Textarea.displayName = 'Textarea';

export { Textarea };
